import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Button, CardActionArea, CardActions } from '@mui/material';

import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';


export default function AppstoreApps() {
    return (
        <Stack direction="row" spacing={2}>
            <Card sx={{ maxWidth: 345 }}>
                <CardActionArea>
                    <CardMedia
                        component="img"
                        height="140"
                        image="/images/SBS_logo.png"
                        alt="Schneider"
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            Utility Data Hub
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Add data stores and connect to Autodesk Vault from directly within Abraxas.
                        </Typography>
                    </CardContent>
                </CardActionArea>
                <CardActions>
                    <Button size="small" color="primary">
                        Read More
                    </Button>
                </CardActions>
            </Card>

            <Card sx={{ maxWidth: 345 }}>
                <CardActionArea>
                    <CardMedia
                        component="img"
                        height="140"
                        image="/images/Schneider_Electric-Logo.wine.png"
                        alt="Schneider"
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            Thermal monitoring
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Monitor and provide thermal data of your cable connections
                        </Typography>
                    </CardContent>
                </CardActionArea>
                <CardActions>
                    <Button size="small" color="primary">
                        Add to Project
                    </Button>
                </CardActions>
            </Card>

            <Card sx={{ maxWidth: 345 }}>
                <CardActionArea>
                    <CardMedia
                        component="img"
                        height="140"
                        image="/images/monnitlogo.png"
                        alt="Sensu"
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                            Monnit Mine
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Authenticate and monitor Monnit sensors remotely from within Abraxas
                        </Typography>
                    </CardContent>
                </CardActionArea>
                <CardActions>
                    <Button size="small" color="primary">
                            Add to Project
                    </Button>
                </CardActions>
            </Card>
        </Stack>
    );
}